export const ORDER_HEADER_PICKUP = 'order.header.pickup';
export const ORDER_HEADER_SHIPMENT = 'order.header.shipment';
export const ORDER_HEADER_DELIVERY = 'order.header.delivery';
export const CATERING_HEADER_DELIVERY = 'catering.order.header.delivery';
